import { connect } from "react-redux";
import { ImageDiscoveryCanvas as Component } from "../ImageDiscoveryCanvas";
import { updateSelectedHotspot } from "./store/actions";

function mapDispatchToProps(dispatch) {
  return {
    updateSelectedHotspot: (params) => {
      dispatch(updateSelectedHotspot(params));
    },
  };
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    requiresRedux: true,
  };
}

export const ImageDiscoveryCanvasRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
